import React from "react"
import AbstractMedia from "../../components/abstractMedia/AbstractMedia"
import Title from "../../components/Title"

const TitleBlock = ({ data, media }) => {
  return (
    <div className="title-block">
      <div className="container-fluid">
        <div className="title-block-container">
          <AbstractMedia
            abstractMedia={data.image}
            media={media}
            title={data.titre}
          />
          {data.block || (
            <Title balise={data["balise du titre"]} className="container">
              {data.titre}
            </Title>
          )}
        </div>
      </div>
    </div>
  )
}

export default TitleBlock
